import React, { FC, PropsWithChildren, useMemo, useState } from 'react';

import {
    CurrentUserActionIndicatorContext,
    UserActionIndicatorChangerContext,
} from '../../../../contexts/user-action-indicator';
import {
    UserActionIndicatorChangers,
    UserActionIndicators,
} from '../../../../types/user-action-indicator';

export const UserActionIndicatorProvider: FC<PropsWithChildren> = ({ children }) => {
    const [currentIndicator, setCurrentIndicator] = useState<UserActionIndicators | null>(null);

    const indicatorChangers: UserActionIndicatorChangers = useMemo(
        () => ({
            showPlay: () => setCurrentIndicator('play'),
            showPause: () => setCurrentIndicator('pause'),
            showSeekForward: () => setCurrentIndicator('seekForward'),
            showSeekBackward: () => setCurrentIndicator('seekBackward'),
            clearIndicator: () => setCurrentIndicator(null),
        }),
        []
    );

    return (
        <CurrentUserActionIndicatorContext.Provider value={currentIndicator}>
            <UserActionIndicatorChangerContext.Provider value={indicatorChangers}>
                {children}
            </UserActionIndicatorChangerContext.Provider>
        </CurrentUserActionIndicatorContext.Provider>
    );
};
